'use client';

import React, { useState } from 'react';
import { Download, ChevronDown } from 'lucide-react';

const payPeriods = [
  { id: 'pp-current', label: 'Current: Jul 28 – Aug 3, 2026' },
  { id: 'pp-prev1', label: 'Jul 14 – Jul 27, 2026' },
  { id: 'pp-prev2', label: 'Jun 30 – Jul 13, 2026' },
  { id: 'pp-prev3', label: 'Jun 16 – Jun 29, 2026' },
];

export default function TimeTrackingHeader() {
  const [activePeriod, setActivePeriod] = useState(payPeriods?.[0]);
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-2xl font-semibold text-foreground tracking-tight">Time Tracking</h1>
        <p className="text-sm text-muted-foreground mt-1">Shift logs, clock events, and overtime tracking</p>
      </div>
      <div className="flex items-center gap-3">
        {/* Pay period selector */}
        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center gap-2 px-3.5 py-2 rounded-lg border border-border bg-card text-sm font-500 text-foreground hover:bg-muted transition-colors"
          >
            <span className="text-muted-foreground text-xs">Pay Period:</span>
            <span>{activePeriod?.label}</span>
            <ChevronDown size={14} />
          </button>
          {showDropdown && (
            <div className="absolute right-0 top-full mt-1 w-64 bg-card border border-border rounded-lg shadow-elevated z-50 py-1 scale-in">
              {payPeriods?.map((p) => (
                <button
                  key={p?.id}
                  onClick={() => { setActivePeriod(p); setShowDropdown(false); }}
                  className={`w-full text-left px-4 py-2.5 text-sm hover:bg-muted transition-colors ${
                    activePeriod?.id === p?.id ? 'text-primary font-600 bg-primary/5' : 'text-foreground'
                  }`}
                >
                  {p?.label}
                </button>
              ))}
            </div>
          )}
        </div>
        <button className="flex items-center gap-2 px-3.5 py-2 rounded-lg border border-border bg-card text-sm font-500 text-foreground hover:bg-muted transition-colors">
          <Download size={15} />
          Export
        </button>
      </div>
    </div>
  );
}